import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import Spinner from 'react-bootstrap/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchUserApi } from './userSlice';
import DataTableFilter from '~/components/Datatable/ReactDatatableComponent/DataTableFilter';

const columns = [
    {
        name: '#',
        selector: (row) => row.id,
    },
    {
        name: 'halfwish_id',
        selector: (row) => row.halfwish_id,
        sortable: true,
    },
    {
        name: 'Name',
        selector: (row) => row.name,
        sortable: true,
    },
    {
        name: 'email',
        selector: (row) => row.email,
        sortable: true,
    },
];

const customStyles = {
    headCells: {
        style: {
            fontWeight: 'bold', // override the cell padding for head cells
        },
    },
};

function User() {
    const [filterText, setFilterText] = useState('');
    const { rows, totalRows, perPage, page } = useSelector((state) => state.user.user);

    const { isLoading } = useSelector((state) => state.loading);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (rows.length > 0) return;

        (async function () {
            await fetchApi(page, perPage, filterText);
        })();
    }, []);

    const handlePageChange = async (page) => await fetchApi(page, perPage, filterText);

    const handlePerPageChange = async (perPage, page) => await fetchApi(page, perPage, filterText);

    const fetchApi = async (page, perPage, filterText) => {
        const params = {
            page,
            perPage,
            filterText
        };
        dispatch(fetchUserApi(params, navigate));
    };

    const handleClear = async () => {
        if (filterText) {
            setFilterText('');
            await fetchApi(page, perPage, '');
        }
    };

    const handleUpdateFilter = async () => {
        if (filterText != '') {
            await fetchApi(page, perPage, filterText);
        }
    };

    return (
        <div className="col-sm-12">

            <div className="float-right">
                <DataTableFilter
                    onUpdateFilter={handleUpdateFilter}
                    onFilter={(e) => setFilterText(e.target.value)}
                    onClear={handleClear}
                    filterText={filterText}
                />
            </div>
            <DataTable
                columns={columns}
                data={rows}
                fixedHeader
                striped
                pagination
                noDataComponent={<h3 className="m-3">No data...</h3>}
                progressPending={isLoading} //spinning icon will trigger when isLoading = 1
                progressComponent={
                    // eslint-disable-next-line prettier/prettier
                    <Spinner
                        animation="border"
                        role="status"
                    >
                        <span className="visually-hidden"></span>
                    </Spinner>
                }
                customStyles={customStyles}
                paginationServer
                persistTableHead
                onChangePage={handlePageChange}
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerPageChange}
                paginationRowsPerPageOptions={[5, 10, 15, 20, 50]}
                paginationPerPage={perPage}
                paginationDefaultPage={page}
            />
        </div>
    );
}
//ref: https://codesandbox.io/s/gws1i?file=/src/App.js (datatable with filtering)
export default User;
